// ---------------------------------------------------------------------------
// Shared error display component
// ---------------------------------------------------------------------------

interface ErrorStateProps {
  /** Error message to display. */
  message: string;
  /** Optional retry callback. When provided, a retry button is shown. */
  onRetry?: () => void;
}

export function ErrorState({ message, onRetry }: ErrorStateProps) {
  return (
    <div className="p-6">
      <div
        className="bg-danger-tint border border-danger/25 rounded-sm p-4 text-ink"
        role="alert"
      >
        <p className="font-semibold text-danger">Something went wrong</p>
        <p className="mt-1 text-sm text-ink-muted">{message}</p>
        {onRetry && (
          <button
            type="button"
            onClick={onRetry}
            className="mt-3 px-3 py-1.5 text-sm font-medium bg-white border border-danger/30 hover:border-danger text-danger rounded-sm transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-danger focus-visible:ring-offset-2 focus-visible:ring-offset-danger-tint"
          >
            Try again
          </button>
        )}
      </div>
    </div>
  );
}
